import { render } from "./info.vue?vue&type=template&id=2c4240aa&scoped=true&ts=true"
import script from "./info.vue?vue&type=script&lang=ts"
export * from "./info.vue?vue&type=script&lang=ts"

import "./info.vue?vue&type=style&index=0&id=2c4240aa&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4240aa"]])

export default __exports__